module.exports = __webpack_public_path__ + "img/luisdtorresp-logo.4a69119c.svg";